<template>
    <v-card class="elevation-1 round-card background-1 mr-4">
        <v-card-title
            class="pa-3 pb-1 cursor-pointer"
            @click="$emit('toggle')"
        >
            <div class="d-flex align-center flex-wrap" style="width: 100%">
                <v-avatar
                    v-if="comment.user && comment.user.avatar"
                    size="32"
                    class="mr-2 custom-avatar"
                    :style="{'background-image': 'url(' + comment.user.avatar + ')'}"
                ></v-avatar>
                <v-avatar
                    v-else
                    color="purple"
                    size="32"
                    class="mr-2"
                >
                    <v-icon dark small>mdi-share</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                    <div class="subtitle-1 font-weight-medium" style="line-height: 1">
                        {{ comment.user ? comment.user.name : 'Sistema' }}
                    </div>
                    <div class="caption grey--text">
                        Email inoltrata{{ formattedTo ? ` a ${formattedTo}` : '' }}
                    </div>
                </div>
                <div class="caption grey--text text-right d-flex align-center">
                    <v-chip x-small class="mr-2" color="purple" dark>
                        <v-icon x-small left>mdi-share</v-icon>
                        Inoltro
                    </v-chip>
                    {{ comment.created_at | datetime }}
                    <v-icon small class="ml-2">
                        {{ collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up' }}
                    </v-icon>
                </div>
            </div>
        </v-card-title>

        <template v-if="!collapsed">
            <v-divider></v-divider>
            <v-card-text class="pa-3">
                <div class="caption mb-1" v-if="formattedTo">
                    <span class="grey--text">A:</span> {{ formattedTo }}
                </div>
                <div class="caption mb-2" v-if="payload.cc && payload.cc.length">
                    <span class="grey--text">CC:</span> {{ payload.cc.join(', ') }}
                </div>

                <template v-if="payload.note">
                    <v-divider class="my-2"></v-divider>
                    <div class="caption grey--text mb-1">Nota</div>
                    <div
                        v-if="isHtml(payload.note)"
                        v-html="sanitizeHtml(payload.note)"
                        class="comment-body"
                    ></div>
                    <div v-else class="comment-body">
                        {{ payload.note }}
                    </div>
                </template>
            </v-card-text>
        </template>
    </v-card>
</template>

<script>
import { sanitizeHtml } from '@/utils/sanitizeHtml'

export default {
    name: 'ForwardTimelineItem',

    props: {
        comment: {
            type: Object,
            required: true
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        payload() {
            if (!this.comment.text) return {}
            try {
                return JSON.parse(this.comment.text) || {}
            } catch (e) {
                return { note: this.comment.text }
            }
        },

        // Normalizza il campo `to` come stringa: il backend lo salva sempre stringa
        // (validation `required|email`), ma se in futuro diventasse array lo serializziamo
        // come "a, b, c" senza rotture nel template.
        formattedTo() {
            const to = this.payload.to
            if (!to) return ''
            return Array.isArray(to) ? to.join(', ') : to
        }
    },

    methods: {
        sanitizeHtml,

        isHtml(content) {
            if (!content) return false
            return /<[a-z][\s\S]*>/i.test(content)
        }
    }
}
</script>

<style scoped>
.custom-avatar {
    background-size: cover;
    background-position: center;
}

.comment-body {
    max-height: 300px;
    overflow-y: auto;
}
</style>
